import axios from 'axios';

// Judge0 API 基础配置
const API_BASE_URL = 'https://api.flybirdai.com:3000';

// 语言ID
export const LANGUAGE_IDS = {
  'cpp': 54,    // C++ (GCC 9.2.0)
  'python': 71, // Python 3.8.1
  'c': 50       // C (GCC 9.2.0)
};

// 状态ID对应的描述
export const STATUS_DESCRIPTIONS: { [key: number]: string } = {
  1: '队列中',
  2: '处理中',
  3: '已完成',
  4: '编译错误',
  5: '运行时错误',
  6: '超时错误',
  7: '内存超限',
  8: '其他错误'
};

// 解码base64数据
const decodeBase64 = (base64: string) => {
  try {
    const binString = window.atob(base64);
    const bytes = new Uint8Array(binString.length);
    for (let i = 0; i < binString.length; i++) {
      bytes[i] = binString.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error('Base64解码失败:', error);
    return '';
  }
};

// 提交代码执行请求
export const submitCode = async (
  languageId: number,
  sourceCode: string,
  stdin: string = '',
  compilerOptions: string = ''
) => {
  try {
    const options = {
      method: "POST",
      url: `${API_BASE_URL}/submissions`,
      params: { base64_encoded: "false" },
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      withCredentials: false,
      data: {
        language_id: languageId,
        source_code: sourceCode,
        stdin: stdin,
        compiler_options: compilerOptions
      }
    };
    
    const response = await axios.request(options);
    return response.data;
  } catch (error) {
    console.error('提交代码执行请求失败:', error);
    throw error;
  }
};

// 查询执行结果
export const getSubmissionResult = async (token: string) => {
  try {
    const options = {
      method: "GET",
      url: `${API_BASE_URL}/submissions/${token}`,
      params: { base64_encoded: "true" },
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      withCredentials: false
    };
    
    const response = await axios.request(options);
    
    // 处理base64编码的响应
    if (response.data.stdout) {
      response.data.stdout = decodeBase64(response.data.stdout);
    }
    if (response.data.stderr) {
      response.data.stderr = decodeBase64(response.data.stderr);
    }
    if (response.data.compile_output) {
      response.data.compile_output = decodeBase64(response.data.compile_output);
    }
    
    return response.data;
  } catch (error) {
    console.error('查询执行结果失败:', error);
    throw error;
  }
};

// 轮询获取执行结果（直到完成或出错）
export const pollSubmissionResult = async (token: string, maxAttempts: number = 10, interval: number = 2000) => {
  let attempts = 0;
  
  while (attempts < maxAttempts) {
    try {
      const result = await getSubmissionResult(token);
      
      // 如果状态ID为3（已完成）或大于3（出错），则返回结果
      if (result.status?.id >= 3) {
        return result;
      }
      
      // 否则等待一段时间后再次查询
      await new Promise(resolve => setTimeout(resolve, interval));
      attempts++;
    } catch (error) {
      console.error('轮询执行结果失败:', error);
      attempts++;
      // 错误后继续尝试，而不是立即中断
      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }
  
  throw new Error('执行超时，请稍后再试');
};